<div class="layout-inner">
  <div class="footer">
    <ul>
      <li class="logo"><a target="_blank" rel="nofollow" (click)="onLinkClick(links.google)">
        <img src="assets/img/Google_logo.svg" alt="logo1">
      </a></li>
      <li><a target="_blank" rel="nofollow" (click)="onLinkClick(links.googleAbout)">{{'app.footer.about' | translate}}</a></li>
      <li><a target="_blank" rel="nofollow" (click)="onLinkClick(links.googleProducts)">{{'app.footer.products' | translate}}</a></li>
      <li><a target="_blank" rel="nofollow" (click)="onLinkClick(links.privacy)">{{'app.footer.conf' | translate}}</a></li>
      <li><a target="_blank" rel="nofollow" (click)="onLinkClick(links.policies)">{{'app.footer.terms-teleport' | translate}}</a></li>
    </ul>
  </div>
</div>

